import axios from 'axios';

import { getLocaleWithRegion } from '@gn-audio/jss-core/common/utilities';

export const getFamilyAwards = async (
  marketingDocumentsBaseUrl: string,
  familyId: string,
  locale: string
) => {
  const localeWithRegion = getLocaleWithRegion(locale);
  const url = `${marketingDocumentsBaseUrl}/families/${familyId}/awards?marketLocale=${localeWithRegion}&country=${localeWithRegion.split('-')[1]}`;
  const res = await axios.get(url);
  return res.data;
};
